import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  page: 1,
  itemsPerPage: 10,
  productsOrder: [],
  identifier:''
};

const pluginOrdersSlice = createSlice({
  name: 'pluginOrdersUI',
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    setProductsOrder: (state, action) => {
      state.productsOrder = action.payload;
    },
    setIdentifier: (state, action) => {
      state.identifier = action.payload
    },
    resetFilters: () => initialState,
  },
});

export const { setPage, setItemsPerPage, resetFilters, setProductsOrder, setIdentifier } = pluginOrdersSlice.actions;
const userPluginOrdersReducer = pluginOrdersSlice.reducer;
export default userPluginOrdersReducer;
